import { PageLoading } from "@ant-design/pro-components";

export default PageLoading;
